import { render, staticRenderFns } from "./PerformanceTable.vue?vue&type=template&id=5bb8c381&scoped=true"
import script from "./PerformanceTable.vue?vue&type=script&lang=ts"
export * from "./PerformanceTable.vue?vue&type=script&lang=ts"
import style0 from "./PerformanceTable.vue?vue&type=style&index=0&id=5bb8c381&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb8c381",
  null
  
)

export default component.exports